import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";
import { cn } from "../../utilities/tailwind";

/**
 * Props for VisuallyHidden component.
 */
export type VisuallyHiddenProperties<C extends ElementType = "span"> = {
  as?: C;
  children?: ReactNode;
  className?: string;
} & ComponentPropsWithoutRef<C>;
/**
 * VisuallyHidden component.
 */
export const VisuallyHidden = ({
  as = "span",
  children,
  className,
  ...rest
}: VisuallyHiddenProperties) => {
  const Component = as;
  return (
    <Component {...rest} className={cn(className, "sr-only")}>
      {children}
    </Component>
  );
};
VisuallyHidden.displayName = "VisuallyHidden";
